export default __webpack_public_path__ + "static/media/no-races.c19b6442.png";